import React from 'react';
import Toolbar from './../_toolbar';

class TextPlain extends React.Component {

  render(){

    const { component } = this.props;
    const { element }   = component;

    return(
      <div>
        <Toolbar component={ component }/>
        <p>{ element.text }</p>
      </div>
    )

  }

}

export default TextPlain;
